<div class="d-flex flex-column p-4">
  <h2 class="semi-bold d-md-none">Best first fare found. We will beat this fare with your help</h2>

  <h1 class="semi-bold d-none d-md-inline">
    Best first fare found.<br />We will beat this fare with your help
  </h1>

  <quick-option-itinerary
    *ngIf="flightOption; else loadingTemplate"
    [portalLead]="portalLead"
    [flightOption]="flightOption"
    class="mt-4 mt-md-6"
  />

  <h3 class="bold mt-6 mt-md-8">What do you think about the baseline option?</h3>
  <p class="mt-1">Your answer helps us beat this fare</p>

  <div class="mt-4 buttons">
    <radio-toggle-button
      *ngFor="let option of options"
      (click)="selectFeedbackOption(option)"
      [isSelected]="feedbackOption === option"
      [title]="option.label"
      [value]="option.value"
      data-id="{{ option.value }}"
    />
  </div>

  <form [formGroup]="form">
    <div *ngIf="feedbackOption?.extra?.withRange" class="d-flex flex-column mt-4 mt-md-8">
      <h3 class="semi-bold">What’s your budget per person?</h3>

      <p class="mt-1">This helps our agents find unpublished fares closer to your target range.</p>

      <div class="d-flex mt-4 g-4">
        <div class="flex-1">
          <ds-currency-input
            formControlName="budgetFrom"
            label="From"
            placeholder="2,000"
            data-id="from"
          />
        </div>

        <div class="flex-1">
          <ds-currency-input
            formControlName="budgetTo"
            label="To"
            placeholder="3,500"
            data-id="to"
          />
        </div>
      </div>
    </div>

    <div class="d-flex flex-column flex-md-row mt-4 mt-md-8">
      <div class="flex-1">
        <ds-input
          formControlName="comment"
          label="Leave a comment (Optional)"
          placeholder="Write your comment here"
          data-id="comment"
        />
      </div>

      <p class="mt-4 d-md-none">We’ll use your feedback to find better fares</p>

      <div class="d-flex mt-2 mt-md-0 ml-md-4">
        <ds-button
          (click)="submit()"
          [disabled]="loading || !feedbackOption"
          label="Get my personalized fares"
          [fullWidth]="true"
          class="mt-auto nowrap"
          data-id="submit"
        />
      </div>
    </div>
  </form>
</div>

<ng-template #loadingTemplate>
  <ds-skeleton [height]="250" class="mt-6 mt-md-8" />
</ng-template>
